import { defineComponent as _defineComponent } from 'vue'
import CcBudget from '@/views/Automation/CampaignCreatorV2/components/CcBudget/CcBudget.ts.vue';
import CcCard from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCard.ts.vue';
import CcCardItem from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCardItem.ts.vue';
import CcCheckbox from '@/views/Automation/CampaignCreatorV2/components/CcCheckbox/CcCheckbox.ts.vue';
import CcError from '@/views/Automation/CampaignCreatorV2/components/CcError/CcError.ts.vue';
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import CcActionsPopover from '@/views/Automation/CampaignCreatorV2/components/CcPopover/CcActionsPopover.ts.vue';
import {
  AddBudgetTypeDropdownEvent,
  ViewLevelActionsEvent,
} from '@/views/Automation/CampaignCreatorV2/components/CcPopover/helpers';
import CcVariableTags from '@/views/Automation/CampaignCreatorV2/components/CcVariableTags/CcVariableTags.ts.vue';
import TreeselectInfoOption from '@/views/Automation/CampaignCreatorV2/components/Treeselect/TreeselectInfoOption.ts.vue';
import { BidStrategy } from '@/views/Automation/CampaignCreatorV2/helpers/facebook/Campaign';
import useCampaignStore from '@/views/Automation/CampaignCreatorV2/store/Campaign';
import { InternalABVariable, SupportedEntities } from '@/views/Automation/CampaignCreatorV2/store/Types';
import { CardLayer } from '@/views/Automation/CampaignCreatorV2/types';
import { CampaignAbGroupTypes } from '@/views/Automation/CampaignCreatorV2/validation/Campaign';
import Treeselect from '@riophae/vue-treeselect';
import { Position } from '@sh/types';
import { storeToRefs } from 'pinia';
import uid from 'uid';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvantageCampaignBudget.ts',
  setup(__props) {

const abGroupType = ref(CampaignAbGroupTypes.CampaignBudget);

const campaignStore = useCampaignStore();
const { getIsCampaignBudgetActive, getField, getAllowedBidOptions } = storeToRefs(campaignStore);

const BidStrategyOptions = computed(() => {
  return getAllowedBidOptions.value;
});

const isCampaignBudgetActive = computed(() => getIsCampaignBudgetActive.value);

const dailyBudget = computed(() => {
  const daily = getField.value('daily_budget');
  const newValues = daily?.value.map((c) => ({ ...c, value: c.value / 100 }));
  return { ...daily, value: newValues };
});

const lifetimeBudget = computed(() => {
  const daily = getField.value('lifetime_budget');
  const newValues = daily?.value.map((c) => ({ ...c, value: c.value / 100 }));
  return { ...daily, value: newValues };
});

const bidStrategy = computed(() => getField.value('bid_strategy')?.value?.[0] || {});

const spendCap = computed(() => {
  const cap = getField.value('spend_cap')?.value?.[0] || {};
  return {
    ...cap,
    value: cap.value / 100,
  };
});

function onCampaignBudgetActiveChange(value: boolean) {
  campaignStore.switchCampaignBudgetMode(value);
}

function onUpdateSpendingLimit(value: string) {
  campaignStore.addOrEditVariable('spend_cap', {
    field: 'spend_cap',
    value: parseFloat(value) * 100,
    variableId: 'spend_cap',
  });
}

function updateBudget(value: { budget_type: string; value: string }, existingVariable: InternalABVariable<unknown>) {
  if (existingVariable.field !== value.budget_type) {
    campaignStore.removeVariable(existingVariable.field as 'daily_budget', existingVariable.variableId);
  }
  campaignStore.addOrEditVariable(value.budget_type as 'daily_budget', {
    field: value.budget_type,
    value: parseFloat(value.value) * 100,
    variableId: existingVariable.variableId,
  });
}

function onBidStrategyChange(value: { id: any }) {
  campaignStore.addOrEditVariable('bid_strategy', {
    field: 'bid_strategy',
    value: value.id,
    variableId: 'bid_strategy',
  });
}

function addNewBudget(event: ViewLevelActionsEvent) {
  const field = event === AddBudgetTypeDropdownEvent.ADD_DAILY_BUDGET ? 'daily_budget' : 'lifetime_budget';
  const variableId = uid();

  campaignStore.addVariable(field, {
    field,
    value: 25 * 100,
    variableId,
    name: `Budget Variant ${variableId}`,
  });
  onBidStrategyChange({
    id: BidStrategy.LOWEST_COST_WITH_BID_CAP,
  });
}

function onRemoveSpendCap(value: boolean) {
  if (!value) {
    campaignStore.removeVariable('spend_cap', 'spend_cap');
  }
  if (value) campaignStore.addVariable('spend_cap', { field: 'spend_cap', value: 1, variableId: 'spend_cap' });
}

function handleRenameBudgetVariation({
  budget,
  newName,
}: {
  budget: InternalABVariable<unknown> & { field: 'daily_budget' | 'lifetime_budget' };
  newName: string;
}) {
  campaignStore.addOrEditVariableName(budget.field, budget.abGroup!, budget.variableId, newName);
}

function removeDailyBudget(variableId: string) {
  campaignStore.removeVariable('daily_budget', variableId);
}

function removeLifetimeBudget(variableId: string) {
  campaignStore.removeVariable('lifetime_budget', variableId);
}

return { __sfc: true,abGroupType, campaignStore, getIsCampaignBudgetActive, getField, getAllowedBidOptions, BidStrategyOptions, isCampaignBudgetActive, dailyBudget, lifetimeBudget, bidStrategy, spendCap, onCampaignBudgetActiveChange, onUpdateSpendingLimit, updateBudget, onBidStrategyChange, addNewBudget, onRemoveSpendCap, handleRenameBudgetVariation, removeDailyBudget, removeLifetimeBudget, CcBudget, CcCard, CcCardItem, CcCheckbox, CcError, CcIcon, CcActionsPopover, AddBudgetTypeDropdownEvent, CcVariableTags, TreeselectInfoOption, SupportedEntities, CardLayer, Treeselect, Position }
}

})